import React, { useState, useEffect } from 'react';
import { Input, Select, Button } from 'antd';
import { useHistory } from 'react-router';
import { allLocations } from '../../../services/admin';
import { allCategories } from '../../../services/product';
import HomeContent from '../home-content';
import Footer from '../../../components/layout/footer';
import SponsoredProducts from '../../../components/product/sponsored-products';
import { WhatsAppOutlined } from '@ant-design/icons'; // Importando o ícone do WhatsApp

const { Search } = Input;
const { Option } = Select;

const Home = () => {
  const [categories, setCategories] = useState([]);
  const [locations, setLocations] = useState([]);
  const [search, setSearch] = useState({
    location: '',
    category: '',
    name: '',
    condition: '',
    price: [],
  });

  const { location, category, name, condition, price } = search;
  const history = useHistory();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 600);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    loadCategories();
    loadLocations();
  }, []);

  const loadCategories = async () => {
    const res = await allCategories();
    setCategories(res.data);
  };
  const loadLocations = async () => {
    const res = await allLocations();
    setLocations(res.data);
  };

  const handleLocation = (value) => setSearch({ ...search, location: value });
  const handleCategory = (value) => setSearch({ ...search, category: value });
  const handleSearch = (e) => setSearch({ ...search, name: e.target.value });
  const handleSubmit = () => {
    history.push(
      `search-result?&location=${location}&category=${category}&name=${name}&price=${price}&condition=${condition}`
    );
  };

  const heroStyle = {
    background: `url('${isMobile ? process.env.REACT_APP_MOBILE_BACKGROUND_PATH || '/01-mobile.jpg' : process.env.REACT_APP_BACKGROUND_PATH || '/01.jpg'}') center center/cover no-repeat`,
    minHeight: isMobile ? 400 : 480,
    position: 'relative',
    width: '100%',
    maxWidth: '100vw',
    aspectRatio: '16/6',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: isMobile ? 'contain' : 'cover',
    backgroundColor: isMobile ? 'white' : 'transparent',
    margin: 0,
    padding: 0,
    borderRadius: isMobile ? '0 0 18px 18px' : 0,
  };

  return (
    <>
      {/* Sponsored Ads */}
      <SponsoredProducts />

      {/* Conteúdo abaixo do hero */}
      <HomeContent
        categories={categories}
        locations={locations}
        handleClick={() => {}}
      />

      {/* Botão flutuante do WhatsApp */}
      {process.env.REACT_APP_SHOW_WHATSAPP_BUTTON === 'true' && (
        <a
          href={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NUMBER || '5511999999999'}`}
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-button"
        >
          <WhatsAppOutlined className="whatsapp-icon" />
        </a>
      )}
    </>
  );
};

export default Home;
